{
  "0b20d6c68a3c4706": "Visit updates",
  "25181e0f807f4bbc": "Don't miss reminders to verify outstanding visits.",
  "2ac741e6203af759": "Maybe later",
  "2b194934439e9665": "Shift bookings",
  "3fea642185ba9acd": "Stay up to date",
  "4165e2978c2117ef": "Chat messages",
  "682be64ae7801fd0": "Enable notifications",
  "894dcbb521a1269c": "Verification reminders",
  "8a4dd392e661b037": "Schedule changes",
  "bb665d949734749a": "This notification has expired",
  "be3df4f3d324f259": "Know the moment a shift is claimed or cancelled.",
  "bf28ed42be7d72ef": "Know the moment a shift is claimed or canceled.",
  "cdd5d0719a0e47f5": "Turn on push notifications to get timely updates — even when the app is closed.",
  "d5936d76aa451f83": "Know when a visit is confirmed, logged, or a professional is unassigned.",
  "d735e44ede615db9": "Stay on top of last-minute updates to your calendar.",
  "dc78a7975e25749f": "Reply to professionals without keeping a tab open."
}
